/* Cervly — storefront interactions (vanilla, no deps) */
(function () {
  'use strict';

  /* Mobile menu toggle */
  document.addEventListener('click', function (e) {
    var burger = e.target.closest('[data-cv-burger]');
    if (burger) {
      var menu = document.getElementById('cv-mobile-menu');
      if (menu) menu.classList.toggle('is-open');
    }
  });

  /* Accordions (FAQ / specs) */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('.cv-acc__q');
    if (!q) return;
    var row = q.closest('.cv-acc__row');
    var sign = q.querySelector('.cv-acc__sign');
    var open = row.classList.toggle('is-open');
    if (sign) sign.textContent = open ? '\u2212' : '+';
  });

  /* Product gallery thumbnails */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.cv-thumb');
    if (!thumb) return;
    var gallery = thumb.closest('[data-cv-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-cv-gallery-main]');
    var full = thumb.getAttribute('data-full');
    if (main && full) main.src = full;
    gallery.querySelectorAll('.cv-thumb').forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  /* Quantity steppers */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cv-qty]');
    if (!btn) return;
    var wrap = btn.closest('.cv-qty');
    var input = wrap.querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    v += (btn.getAttribute('data-cv-qty') === 'inc') ? 1 : -1;
    input.value = Math.max(1, v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Cart line quantity steppers (submit the cart form) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cv-cart-qty]');
    if (!btn) return;
    var wrap = btn.closest('.cv-qty');
    var input = wrap.querySelector('input[name="updates[]"]');
    var v = parseInt(input.value, 10) || 0;
    v += (btn.getAttribute('data-cv-cart-qty') === 'inc') ? 1 : -1;
    input.value = Math.max(0, v);
    var form = btn.closest('form');
    if (form) form.submit();
  });

  /* Variant picker -> updates hidden id + price + button */
  document.querySelectorAll('[data-cv-product]').forEach(function (root) {
    var data;
    try { data = JSON.parse(root.querySelector('[data-cv-variants]').textContent); } catch (err) { return; }
    var idInput = root.querySelector('[data-cv-variant-id]');
    var priceNow = root.querySelector('[data-cv-price-now]');
    var addBtn = root.querySelector('[data-cv-add]');
    var selected = {};

    root.querySelectorAll('[data-cv-option]').forEach(function (group) {
      var idx = group.getAttribute('data-cv-option');
      var first = group.querySelector('.cv-swatch.is-active') || group.querySelector('.cv-swatch');
      if (first) selected[idx] = first.getAttribute('data-value');
    });

    function findVariant() {
      return data.variants.find(function (v) {
        return v.options.every(function (opt, i) { return selected[i] === opt; });
      });
    }
    function money(cents) {
      return 'CHF ' + (cents / 100).toLocaleString('de-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    function update() {
      var v = findVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceNow) priceNow.textContent = money(v.price);
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? addBtn.getAttribute('data-label') : 'Ausverkauft';
      }
    }

    root.querySelectorAll('.cv-swatch').forEach(function (sw) {
      sw.addEventListener('click', function () {
        var group = sw.closest('[data-cv-option]');
        var idx = group.getAttribute('data-cv-option');
        selected[idx] = sw.getAttribute('data-value');
        group.querySelectorAll('.cv-swatch').forEach(function (s) { s.classList.remove('is-active'); });
        sw.classList.add('is-active');
        update();
      });
    });
    update();
  });

  /* Add to cart -> show "Wird hinzugefügt…" -> auto-redirect to cart (covers main + sticky ATC) */
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-cv-add]');
      var sticky = document.getElementById('cv-sticky-add');
      if (btn) { btn.disabled = true; btn.textContent = 'Wird hinzugefügt…'; }
      if (sticky) { sticky.disabled = true; sticky.textContent = 'Wird hinzugefügt…'; }
      fetch('/cart/add', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
      })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () { window.location.href = '/cart'; });
    });
  });
})();
